import {AxiosError} from 'axios';
import {deleteUserProfile} from '.';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
interface IUseDeleteImageProfileProps {
  profile_type: string;
  successAction: () => void;
}
const useDeleteImageProfile = ({
  profile_type,
  successAction,
}: IUseDeleteImageProfileProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (guid: string) => {
      return deleteUserProfile(guid, profile_type);
    },
    onSuccess: () => {
      successAction && successAction();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default useDeleteImageProfile;
